import React from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarColaboradorDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class ColaboradoresBox extends React.Component {
  constructor() {
    super();
    this.initNewRow = this.initNewRow.bind(this);
    this.tiposDataSource = [
      { id: "I", descricao: "Interno" },
      { id: "E", descricao: "Externo" },
    ];
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="COLABORADORES">
          <DataGrid
            dataSource={criarColaboradorDs()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            columnAutoWidth={true}
            focusedRowEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode={"form"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column
              dataField={"sequencial"}
              caption={"#"}
              alignment={"center"}
              width={80}
            />
            <Column dataField={"tipo"} caption={"Tipo"}>
              <Lookup
                dataSource={this.tiposDataSource}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>
            <Column dataField={"nome"} caption={"Nome"} />
            <Column dataField={"cpf"} caption={"CPF"} />
            <Column dataField={"matricula"} caption={"Matrícula"} />
            <Column
              dataField={"eEntregador"}
              dataType="boolean"
              caption={"Entregador"}
              edit
            />
            <Column
              dataField={"eFiscal"}
              dataType="boolean"
              caption={"Fiscal"}
            />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  initNewRow(e) {
    e.data.eFiscal = false;
    e.data.eEntregador = false;
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }
}
